import moment from 'moment'
export function calculateStatus (startDay, finishDay, progress) {
  if (progress === 100) {
    return 1
  }
  if (!startDay && !finishDay) {
    return
  }
  const startTimeStamp = startDay?.valueOf()
  const endTimeStamp = finishDay?.valueOf()
  const current = moment().valueOf()
  if (
    startDay && finishDay &&
    ((current - startTimeStamp) / (endTimeStamp - startTimeStamp) * 100 >
    progress)
  ) {
    return 2
  }

  if (
    startDay && finishDay &&
    ((current - startTimeStamp) / (endTimeStamp - startTimeStamp) * 100 <=
    progress)
  ) {
    return 1
  }

  if ((finishDay && current > endTimeStamp) || (startDay && current > startTimeStamp)) {
    return 2
  }
  if (current < startTimeStamp || current < endTimeStamp) {
    return 1
  }
}
